module.exports = __webpack_public_path__ + "assets/icons/contact-go-trashy.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/sidemenu/contact-go-trashy.png
// module id = ./src/styles/icons/sidemenu/contact-go-trashy.png
// module chunks = 0